import React from "react";
import { Box, Skeleton } from "@mui/material";

const DataGridSkeleton = ({
	containerClassName = "order-history-container",
	showTabs = false,
	tabCount = 2,
	actionButtons = 1,
	columns = 4,
	rows = 5,
}) => {
	return (
		<div className={containerClassName}>
			{/* Title Skeleton */}
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					rowGap: 1.25,
					width: "100%",
					mb: 2,
				}}
			>
				<Skeleton variant="text" width={220} height={50} sx={{ borderRadius: "10px" }} />
			</Box>

			{/* Toolbar */}
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 2,
				}}
			>
				<Skeleton variant="rectangular" width={220} height={36} sx={{ borderRadius: "10px" }} />
				{actionButtons > 0 && (
					<Box sx={{ display: "flex", gap: 1 }}>
						{Array.from({ length: actionButtons }).map((_, idx) => (
							<Skeleton
								key={`toolbar-btn-${idx}`}
								variant="rectangular"
								width={140}
								height={36}
								sx={{ borderRadius: "10px" }}
							/>
						))}
					</Box>
				)}
			</Box>

			{/* Main DataGrid Skeleton */}
			<Box
				sx={{
					borderRadius: "10px",
					backgroundColor: (theme) => theme.palette.background.paper,
					"& .MuiDataGrid-main, & .MuiDataGrid-cell, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader, & .MuiDataGrid-footerContainer, & .MuiDataGrid-root":
					{
						backgroundColor: (theme) => theme.palette.background.paper,
					},
					".MuiTablePagination-selectLabel": { marginBottom: 0 },
					".MuiTablePagination-displayedRows": { marginBottom: 0 },
					overflow: "hidden",
				}}
			>
				{/* Header Row */}
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						px: 2,
						py: 1.5,
						borderBottom: "1px solid rgba(0,0,0,0.1)",
					}}
				>
					{Array.from({ length: columns }).map((_, idx) => (
						<Box
							key={`header-col-${idx}`}
							sx={{
								flex: 1,
								pr: idx !== columns - 1 ? 2 : 0,
							}}
						>
							<Skeleton variant="text" height={22} width={`${70 - idx * 5}%`} />
						</Box>
					))}
				</Box>

				{/* Body Rows */}
				{Array.from({ length: rows }).map((_, rowIdx) => (
					<Box
						key={`row-${rowIdx}`}
						sx={{
							display: "flex",
							alignItems: "center",
							px: 2,
							py: 1.25,
							borderBottom:
								rowIdx !== rows - 1
									? "1px solid rgba(0,0,0,0.08)"
									: "none",
						}}
					>
						{Array.from({ length: columns }).map((_, colIdx) => (
							<Box
								key={`cell-${rowIdx}-${colIdx}`}
								sx={{
									flex: 1,
									pr: colIdx !== columns - 1 ? 2 : 0,
								}}
							>
								<Skeleton
									variant="rectangular"
									height={20}
									width={`${80 - colIdx * 8}%`}
									sx={{ borderRadius: "6px" }}
								/>
							</Box>
						))}
					</Box>
				))}

				{/* Footer / Pagination Area */}
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						px: 2,
						py: 1.5,
						borderTop: "1px solid rgba(0,0,0,0.1)",
					}}
				>
					<Skeleton variant="text" width={120} height={20} />
					<Skeleton variant="rectangular" width={100} height={30} sx={{ borderRadius: "6px" }} />
				</Box>
			</Box>
		</div>
	);
};

export default DataGridSkeleton;
